import { render, staticRenderFns } from "./questionTypeRadio.vue?vue&type=template&id=4b189a8c&scoped=true&"
import script from "./questionTypeRadio.vue?vue&type=script&lang=js&"
export * from "./questionTypeRadio.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeRadio.vue?vue&type=style&index=0&id=4b189a8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b189a8c",
  null
  
)

export default component.exports